/* eslint-disable import/prefer-default-export */
import { OTHER_DETAILS } from './expressLetter';

export const MOBILESTATION = 'mobileStationInformation';
export const MOBILEINFORMATION = 'mobileInformation';
export const LICENCE_DETAILS = 'licence-details';

export const MYLICENCE_LOCALISEDNETWORK = [
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'use-of-system',
                label: 'Proposed Use of System',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Network Information',
        fieldList: []
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Operating Address',
        fieldList: [
            {
                id: 'postal-no',
                label: 'Postal code',
                type: 'text'
            },
            {
                id: 'block-no',
                label: 'Block / House No',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                span: 6
            },
            {
                id: 'floor',
                label: 'Floor / Level',
                type: 'text',
                span: 2
            },
            {
                id: 'unit',
                label: 'Unit',
                type: 'text',
                span: 2
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: ' ',
        fieldList: [
            {
                id: 'lat-deg',
                label: 'Latitude Degrees',
                type: 'text',
                span: 4
            },
            {
                id: 'lat-min',
                label: 'Latitude Minutes',
                type: 'text',
                span: 4
            },
            {
                id: 'lat-sec',
                label: 'Latitude Seconds',
                type: 'text',
                span: 4
            },
            {
                id: 'lon-deg',
                label: 'Longitude Degrees',
                type: 'text',
                span: 4
            },
            {
                id: 'lon-minutes',
                label: 'Longitude Minutes',
                type: 'text',
                span: 4
            },
            {
                id: 'lon-sec',
                label: 'Longitude Seconds',
                type: 'text',
                span: 4
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Portable Information',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text',
                span: 4
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text',
                span: 4
            },
            {
                id: 'num-of-portables',
                label: 'Number of Portables',
                type: 'text',
                span: 4
            }
        ]
    }
];
